export default "__VITE_ASSET__BovOn3_P__"